import { render, staticRenderFns } from "./dialogBox.vue?vue&type=template&id=285c4bca&scoped=true&"
import script from "./dialogBox.vue?vue&type=script&lang=js&"
export * from "./dialogBox.vue?vue&type=script&lang=js&"
import style0 from "./dialogBox.vue?vue&type=style&index=0&id=285c4bca&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285c4bca",
  null
  
)

export default component.exports